/**
 * Scroll reveal para las secciones Noble.
 * Anima [data-noble-reveal] al entrar en viewport. Respeta prefers-reduced-motion
 * y degrada mostrando todo si IntersectionObserver no existe.
 */
(function () {
  // Varias secciones cargan este asset; solo la primera debe inicializar.
  if (window.__nobleRevealInit) return;
  window.__nobleRevealInit = true;

  const SELECTOR = '[data-noble-reveal]';
  const VISIBLE = 'is-revealed';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach((el) => el.classList.add(VISIBLE));
  }

  if (reduced || !('IntersectionObserver' in window)) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => revealAll());
    } else {
      revealAll();
    }
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const delay = parseInt(el.dataset.nobleRevealDelay || '0', 10);
        if (delay) {
          setTimeout(() => el.classList.add(VISIBLE), delay);
        } else {
          el.classList.add(VISIBLE);
        }
        observer.unobserve(el);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
  );

  function observe(root) {
    (root || document).querySelectorAll(SELECTOR + ':not(.' + VISIBLE + ')').forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe());
  } else {
    observe();
  }

  // El editor de temas reinyecta secciones; hay que re-observar.
  document.addEventListener('shopify:section:load', (e) => observe(e.target));
})();
